/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-target-blank */
import React,{useState, useEffect} from 'react';
import Icon from 'react-icons-kit';
import {arrows_circle_right} from 'react-icons-kit/linea/arrows_circle_right';
import {arrows_circle_left} from 'react-icons-kit/linea/arrows_circle_left';
import { useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { Navbar } from './Navbar';
import ReactPlayer from 'react-player/youtube';

export const ProductPage = ({productDirectHit, setCategoryText}) => {
  // product state
  const [product, setProduct] = useState(productDirectHit);

  // active images
  const [activeImage, setActiveImage] = useState(0);

  // next slide function
  const nextSlide=()=>{
    setActiveImage(activeImage===product.images.length - 1 ? 0 : activeImage + 1);
  }

  // prev slide functiom
  const prevSlide=()=>{
    setActiveImage(activeImage===0 ? product.images.length - 1 : activeImage - 1);
  }

  // random products function
  const [relatedProducts, setRelatedProducts] = useState([]);
  function getRandomProducts(array, count){
    const shuffled = array.sort(()=>Math.random()-0.5);
    return shuffled.slice(0, count);
  }

  // setting related products
  const data = useSelector((state)=>state.products);
  const {active, products} = data; 
  useEffect(()=>{
    const activeCategoryProducts = products.filter((product)=>product.category===active);
    const activeCategoryProductsWithoutActive = activeCategoryProducts.filter((myProduct)=>myProduct.id !== product.id);
    const randomProducts = getRandomProducts(activeCategoryProductsWithoutActive, 3);
    setRelatedProducts(randomProducts);
    window.scrollTo(0, 0);
  },[product]);

  // handle navigation
  const navigate = useNavigate();
  const handleNavigation=(product)=>{
    setProduct(product);
    const myString = product.category;
    const trimmedString = myString.replace(/\s/g, "").toLowerCase();
    navigate(`/${trimmedString}/${product.id}`);
  }

  return (
    <>
        <Navbar setCategoryText={setCategoryText} />
        <div className='individual-product-section'>
            <div className='product-slider'>
                <span style={{marginRight: 10+'px'}} onClick={prevSlide}
                  className={product.images.length<=1?'hide-span':''}>
                    <Icon icon={arrows_circle_right} size={48} />
                </span>
                <div className='product-image-and-indicators-div'>
                    {product.images.map((image, index)=>(
                        activeImage===index&&(
                        <div className='product-image' key={image.id}>
                          <img src={image.img} alt="product"/>
                        </div>
                        )
                    ))}
                    {product.images.length>1&&(
                    <div className='indicators-div'>
                        {product.images.map((image, index)=>(
                        <div className={activeImage===index?'indicator active':'indicator'} key={image.id}
                          onClick={()=>setActiveImage(index)}>
                            <img src={image.img} alt="product-indicator"/>
                        </div>
                        ))}
                    </div>
                    )}
                </div>
                <span style={{marginLeft: 10+'px'}} onClick={nextSlide}
                  className={product.images.length<=1?'hide-span':''}>
                    <Icon icon={arrows_circle_left} size={48} />
                </span>
            </div>
            <div className='product-other-details'>
                <h2>{product.title}</h2>
                <a href={product.redirectionLink} className='check-prize' target="_blank">Check Prize</a>
                <h3>Return to <Link to="/">Home</Link></h3>          
            </div>
        </div>
        {/* blog */}
        <div className='blog-section'>

          {/* introduction */}
          <h1>{product.blog.introduction.heading}</h1>
          <p>{product.blog.introduction.text}</p>

          {/* content */}
          {product.blog.content.map((data)=>(
            <div key={data.id}>
              <h2>{data.heading}</h2>
              <p>{data.text}</p>
            </div>
          ))}

          {/* conclusion */}
          <h2 className='h2color'>{product.blog.conclusion.heading}</h2>
          <p>{product.blog.conclusion.text}</p>
          <div className='order-now-div'>
            <a href={product.redirectionLink} target="_blank">ORDER NOW</a>
          </div>

          {/* youtube video */}
          {product.blog.youtubeLink&&(
            <div className='youtube-video'>
              <div className='youtube-modal'>
                <ReactPlayer className='youtube-player' url={product.blog.youtubeLink} width={'100%'} height={'100%'} controls/>
              </div>
            </div>
          )}

        </div>

        {/* related products */}
        <div className='products-section'>
            <h2>Related Posts</h2>
            <h3>You might want to view these too!</h3>
            <div className='products-container'>
                {relatedProducts.map((product)=>(
                    <div className='product-card' key={product.id}>
                        <div className='product-main-img'>
                            <img src={product.images[0].img} alt="product"/>
                        </div>
                        <p>{product.blog.title}</p>
                        <button onClick={()=>handleNavigation(product)}>Learn More</button>
                    </div>
                ))}
            </div>
        </div>
    </>
  )
}
